import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import template from './index.vdt';
import { BaseSelect } from '../select/base';
import { _$ } from '../../i18n';
import { isNullOrUndefined } from 'intact-shared';
import { useValue } from './useValue';
import { useLabel } from './useLabel';
import { useLoad } from './useLoad';
import { useFilterable } from './useFilterable';
import { useFields } from './useFields';
var typeDefs = _extends({}, BaseSelect.typeDefs, {
  data: Array,
  trigger: ['click', 'hover'],
  changeOnSelect: Boolean,
  format: Function,
  loadData: Function,
  filter: Function,
  fields: Object
});
var defaults = function defaults() {
  return _extends({}, BaseSelect.defaults(), {
    data: [],
    trigger: 'click',
    format: function format(labels) {
      return labels.join(' / ');
    }
  });
};
export var Cascader = /*#__PURE__*/function (_BaseSelect) {
  _inheritsLoose(Cascader, _BaseSelect);
  function Cascader() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _BaseSelect.call.apply(_BaseSelect, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.fields = useFields();
    _this.value = useValue();
    _this.label = useLabel(_this.fields);
    _this.load = useLoad(_this.fields);
    _this.filterable = useFilterable(_this.input.keywords, _this.value.setValue, _this.fields, _valuesInstanceProperty(_this.value));
    _this.positionObj = {
      my: 'left top',
      at: 'right top',
      collisionDirection: ['left']
    };
    return _this;
  }
  var _proto = Cascader.prototype;
  _proto.getPlaceholder = function getPlaceholder() {
    var _this$get = this.get(),
      placeholder = _this$get.placeholder,
      filterable = _this$get.filterable;
    return isNullOrUndefined(placeholder) ? filterable ? _$('请输入或选择') : _$('请选择') : placeholder;
  };
  _proto.getLabel = function getLabel() {
    return this.label.getLabel();
  };
  _proto.hasValue = function hasValue() {
    var _this$get2 = this.get(),
      value = _this$get2.value;
    var has = _BaseSelect.prototype.hasValue.call(this);
    if (has && !value.length) return false;
    return has;
  };
  return Cascader;
}(BaseSelect);
Cascader.template = template;
Cascader.typeDefs = typeDefs;
Cascader.defaults = defaults;